//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import { formatDateToDDMMYYYYHHMMSS } from '../Utils/datetime';

export interface IEnterpriseGPTApiV1Client {
    /**
     * Get all the client configurations. If the authenticated user has a specific role, the client configurations of that role will be merged
     * @return Success
     */
    getClientConfigurationsOptions(signal?: AbortSignal): Promise<ClientConfiguration>;
    /**
     * Create or update a client configuration for a specific role
     * @param body (optional) 
     * @return No Content
     */
    upsertRoleConfiguration(role: string, body?: ClientConfiguration | undefined, signal?: AbortSignal): Promise<void>;
    /**
     * Get the configuration of a role in JSON format
     * @return Success
     */
    getRoleConfiguration(role: string, signal?: AbortSignal): Promise<string>;
    /**
     * Generate a token for speech services
     * @return Success
     */
    getSpeechServiceToken(signal?: AbortSignal): Promise<SpeechServiceToken>;
    /**
     * Generate a list of all role names
     * @return Success
     */
    getAllRoleNames(signal?: AbortSignal): Promise<string[]>;
    /**
     * Get all the user's conversations
     * @return Success
     */
    getAllUserConversations(signal?: AbortSignal): Promise<Conversation[]>;
    /**
     * Create a conversation
     * @param body (optional) 
     * @return Created
     */
    createConversation(body?: ConversationCreate | undefined, signal?: AbortSignal): Promise<Conversation>;
    /**
     * Delete all the conversations of the authenticated user
     * @return No Content
     */
    deleteAllUserConversations(signal?: AbortSignal): Promise<void>;
    /**
     * Get a conversation by its id
     * @return Success
     */
    getConversationById(id: string, signal?: AbortSignal): Promise<Conversation>;
    /**
     * Delete a conversation
     * @return No Content
     */
    deleteConversation(id: string, signal?: AbortSignal): Promise<void>;
    /**
     * Send an action for the conversation
     * @param body (optional) 
     * @return Success
     */
    patchConversation(id: string, body?: ConversationPatch | undefined, signal?: AbortSignal): Promise<Conversation>;
    /**
     * Save an attachment for the conversation
     * @param file (optional) 
     * @return Success
     */
    uploadAttachment(id: string, file?: FileParameter | undefined, signal?: AbortSignal): Promise<void>;
    /**
     * Delete an attachment
     * @return No Content
     */
    deleteAttachment(id: string, fileName: string, signal?: AbortSignal): Promise<void>;
    /**
     * Get a SAS URL for the attachment
     * @return Success
     */
    getAttachmentSasURL(id: string, fileName: string, signal?: AbortSignal): Promise<string>;
    /**
     * Download an attachment uploaded by the user
     * @return Success
     */
    downloadAttachment(id: string, fileName: string, signal?: AbortSignal): Promise<FileResponse>;
    /**
     * Download a document managed by a GPT (e.g. a source document from a RAG tool)
     * @param documentUrl (optional) 
     * @return Success
     */
    downloadDocument(id: string, documentUrl?: string | undefined, signal?: AbortSignal): Promise<FileResponse>;
    /**
     * Get a page of the user's conversations
     * @param projectId (optional) 
     * @param cursor (optional) 
     * @param limit (optional) 
     * @param fullLoad (optional) 
     * @return Success
     */
    getConversationsPaged(projectId?: string | undefined, cursor?: string | undefined, limit?: number | undefined, fullLoad?: boolean | undefined, signal?: AbortSignal): Promise<ConversationPage>;
    /**
     * Get a user's conversations filtered
     * @param searchText (optional) 
     * @param fullLoad (optional) 
     * @return Success
     */
    getConversationsFiltered(searchText?: string | undefined, fullLoad?: boolean | undefined, signal?: AbortSignal): Promise<Conversation[]>;
    /**
     * Populate lastUpdateOn on conversations
     * @return Created
     */
    populateLastUpdateOn(signal?: AbortSignal): Promise<number>;
    /**
     * Checks if the current user is enrolled in the AI Hub platform
     * @return Success
     */
    isUserEnrolled(signal?: AbortSignal): Promise<void>;
    /**
     * Enrolls the current user in the AI Hub platform
     * @return Success
     */
    enroll(signal?: AbortSignal): Promise<void>;
    /**
     * Unenrolls the current user from the AI Hub platform
     * @return Success
     */
    unenroll(signal?: AbortSignal): Promise<void>;
    /**
     * Get the configurations of all the GPTs enabled for the authenticated user
     * @param includeDefaultGpts (optional) 
     * @return Success
     */
    getGptConfigurations(includeDefaultGpts?: boolean | undefined, signal?: AbortSignal): Promise<GptConfiguration[]>;
    /**
     * Upsert a featured GPT configuration (e.g. SyensqoInformation type)
     * @param body (optional) 
     * @return Success
     */
    upsertFeaturedGptConfiguration(body?: GptConfiguration | undefined, signal?: AbortSignal): Promise<Conversation>;
    /**
     * Create a Personal GPT using the CYOT external API
     * @param name (optional) 
     * @param description (optional) 
     * @param instruction (optional) 
     * @param starters (optional) 
     * @param files (optional) 
     * @param filesToDelete (optional) 
     * @return Success
     */
    createPersonalGpt(name?: string | undefined, description?: string | undefined, instruction?: string | undefined, starters?: string[] | undefined, files?: FileParameter[] | undefined, filesToDelete?: string[] | undefined, signal?: AbortSignal): Promise<GptConfiguration>;
    /**
     * Get all Personal GPTs using the CYOT external API
     * @return Success
     */
    getPersonalGpts(signal?: AbortSignal): Promise<GptConfiguration[]>;
    /**
     * Modify a Personal GPT using the CYOT external API
     * @param name (optional) 
     * @param description (optional) 
     * @param instruction (optional) 
     * @param starters (optional) 
     * @param files (optional) 
     * @param filesToDelete (optional) 
     * @return Success
     */
    modifyPersonalGpt(id: string, name?: string | undefined, description?: string | undefined, instruction?: string | undefined, starters?: string[] | undefined, files?: FileParameter[] | undefined, filesToDelete?: string[] | undefined, signal?: AbortSignal): Promise<GptConfiguration>;
    /**
     * Delete a Personal GPT using the CYOT external API
     * @return Success
     */
    deletePersonalGpt(id: string, signal?: AbortSignal): Promise<boolean>;
    /**
     * Get a Personal GPT model using the CYOT external API
     * @return Success
     */
    getPersonalGpt(id: string, signal?: AbortSignal): Promise<PersonalGptResponse>;
    /**
     * @return Success
     */
    anonymous(signal?: AbortSignal): Promise<void>;
    /**
     * Get the terms of use from the AI Hub platform
     * @return Success
     */
    getTermsOfUse(signal?: AbortSignal): Promise<string>;
    /**
     * Get the user Quota
     * @return Success
     */
    getUserQuota(signal?: AbortSignal): Promise<Quota>;
    /**
     * Get the latest, active survey
     * @return Success
     */
    getLatestSurvey(signal?: AbortSignal): Promise<Survey>;
    /**
     * Delete latest survey
     * @return Success
     */
    deleteLatestSurvey(signal?: AbortSignal): Promise<Survey>;
    /**
     * Get the latest survey raw data without user filtering
     * @return Success
     */
    getLatestSurveyRaw(signal?: AbortSignal): Promise<Survey>;
    /**
     * Get the most recent survey by id naming convention (e.g., s_202507_01)
     * @return Success
     */
    getMostRecentSurvey(signal?: AbortSignal): Promise<Survey>;
    /**
     * Upsert a survey
     * @param body (optional) 
     * @return Success
     */
    upsertSurvey(body?: Survey | undefined, signal?: AbortSignal): Promise<Survey>;
    /**
     * Submit a survey response
     * @param body (optional) 
     * @return Created
     */
    submitSurveyResponse(body?: SurveyResponse | undefined, signal?: AbortSignal): Promise<SurveyResponse>;
    /**
     * Activate a specific survey by setting its partitionKey to 'latest'
     * @param body (optional) 
     * @return Success
     */
    activateSurvey(body?: SurveyActivationRequest | undefined, signal?: AbortSignal): Promise<boolean>;
    /**
     * Deactivate a specific survey by setting its partitionKey to 'deactivated'
     * @param body (optional) 
     * @return Success
     */
    deactivateSurvey(body?: SurveyActivationRequest | undefined, signal?: AbortSignal): Promise<boolean>;
    /**
     * Get the current survey activation status
     * @return Success
     */
    getSurveyStatus(signal?: AbortSignal): Promise<any>;
    /**
     * Get the user preferences
     * @return Success
     */
    getUserPreferences(signal?: AbortSignal): Promise<UserPreferences>;
    /**
     * Update the user preferences
     * @param body (optional) 
     * @return Success
     */
    updateUserPreferences(body?: UserPreferences | undefined, signal?: AbortSignal): Promise<UserPreferences>;
    /**
     * Assign the specified role to the list of users
     * @param body (optional) 
     * @return No Content
     */
    updateUsersRole(body?: UpdateUsersRoleRequest | undefined, signal?: AbortSignal): Promise<void>;
    /**
     * Get all user/role Assignments
     * @return Success
     */
    getAllUserRoleAssignments(signal?: AbortSignal): Promise<UserRoleAssignment[]>;
    /**
     * Delete user data (e.g. association of a role to a certain user)
     * @return No Content
     */
    deleteUserData(userId: string, signal?: AbortSignal): Promise<void>;
}

export class EnterpriseGPTApiV1Client implements IEnterpriseGPTApiV1Client {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all the client configurations. If the authenticated user has a specific role, the client configurations of that role will be merged
     * @return Success
     */
    getClientConfigurationsOptions(signal?: AbortSignal): Promise<ClientConfiguration> {
        let url_ = this.baseUrl + "/api/v1/clientconfigurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientConfigurationsOptions(_response);
        });
    }

    protected processGetClientConfigurationsOptions(response: AxiosResponse): Promise<ClientConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientConfiguration.fromJS(resultData200);
            return Promise.resolve<ClientConfiguration>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientConfiguration>(null as any);
    }

    /**
     * Create or update a client configuration for a specific role
     * @param body (optional) 
     * @return No Content
     */
    upsertRoleConfiguration(role: string, body?: ClientConfiguration | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/clientconfigurations/roles/{role}";
        if (role === undefined || role === null)
            throw new globalThis.Error("The parameter 'role' must be defined.");
        url_ = url_.replace("{role}", encodeURIComponent("" + role));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertRoleConfiguration(_response);
        });
    }

    protected processUpsertRoleConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the configuration of a role in JSON format
     * @return Success
     */
    getRoleConfiguration(role: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/clientconfigurations/roles/{role}";
        if (role === undefined || role === null)
            throw new globalThis.Error("The parameter 'role' must be defined.");
        url_ = url_.replace("{role}", encodeURIComponent("" + role));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoleConfiguration(_response);
        });
    }

    protected processGetRoleConfiguration(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Generate a token for speech services
     * @return Success
     */
    getSpeechServiceToken(signal?: AbortSignal): Promise<SpeechServiceToken> {
        let url_ = this.baseUrl + "/api/v1/clientconfigurations/authorization/speech-service";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpeechServiceToken(_response);
        });
    }

    protected processGetSpeechServiceToken(response: AxiosResponse): Promise<SpeechServiceToken> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SpeechServiceToken.fromJS(resultData200);
            return Promise.resolve<SpeechServiceToken>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpeechServiceToken>(null as any);
    }

    /**
     * Generate a list of all role names
     * @return Success
     */
    getAllRoleNames(signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/clientconfigurations/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllRoleNames(_response);
        });
    }

    protected processGetAllRoleNames(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Get all the user's conversations
     * @return Success
     */
    getAllUserConversations(signal?: AbortSignal): Promise<Conversation[]> {
        let url_ = this.baseUrl + "/api/v1/conversations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUserConversations(_response);
        });
    }

    protected processGetAllUserConversations(response: AxiosResponse): Promise<Conversation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Conversation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Conversation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Conversation[]>(null as any);
    }

    /**
     * Create a conversation
     * @param body (optional) 
     * @return Created
     */
    createConversation(body?: ConversationCreate | undefined, signal?: AbortSignal): Promise<Conversation> {
        let url_ = this.baseUrl + "/api/v1/conversations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateConversation(_response);
        });
    }

    protected processCreateConversation(response: AxiosResponse): Promise<Conversation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = Conversation.fromJS(resultData201);
            return Promise.resolve<Conversation>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Conversation>(null as any);
    }

    /**
     * Delete all the conversations of the authenticated user
     * @return No Content
     */
    deleteAllUserConversations(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAllUserConversations(_response);
        });
    }

    protected processDeleteAllUserConversations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get a conversation by its id
     * @return Success
     */
    getConversationById(id: string, signal?: AbortSignal): Promise<Conversation> {
        let url_ = this.baseUrl + "/api/v1/conversations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConversationById(_response);
        });
    }

    protected processGetConversationById(response: AxiosResponse): Promise<Conversation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Conversation.fromJS(resultData200);
            return Promise.resolve<Conversation>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Conversation>(null as any);
    }

    /**
     * Delete a conversation
     * @return No Content
     */
    deleteConversation(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteConversation(_response);
        });
    }

    protected processDeleteConversation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Send an action for the conversation
     * @param body (optional) 
     * @return Success
     */
    patchConversation(id: string, body?: ConversationPatch | undefined, signal?: AbortSignal): Promise<Conversation> {
        let url_ = this.baseUrl + "/api/v1/conversations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatchConversation(_response);
        });
    }

    protected processPatchConversation(response: AxiosResponse): Promise<Conversation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Conversation.fromJS(resultData200);
            return Promise.resolve<Conversation>(result200);

        } else if (status === 304) {
            const _responseText = response.data;
            return throwException("Not Modified", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Conversation>(null as any);
    }

    /**
     * Save an attachment for the conversation
     * @param file (optional) 
     * @return Success
     */
    uploadAttachment(id: string, file?: FileParameter | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversations/{id}/attachment";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadAttachment(_response);
        });
    }

    protected processUploadAttachment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete an attachment
     * @return No Content
     */
    deleteAttachment(id: string, fileName: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/conversations/{id}/attachment/{fileName}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileName === undefined || fileName === null)
            throw new globalThis.Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAttachment(_response);
        });
    }

    protected processDeleteAttachment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get a SAS URL for the attachment
     * @return Success
     */
    getAttachmentSasURL(id: string, fileName: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/conversations/{id}/attachment/{fileName}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileName === undefined || fileName === null)
            throw new globalThis.Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttachmentSasURL(_response);
        });
    }

    protected processGetAttachmentSasURL(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Download an attachment uploaded by the user
     * @return Success
     */
    downloadAttachment(id: string, fileName: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/conversations/{id}/attachment/{fileName}/download";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileName === undefined || fileName === null)
            throw new globalThis.Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAttachment(_response);
        });
    }

    protected processDownloadAttachment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Download a document managed by a GPT (e.g. a source document from a RAG tool)
     * @param documentUrl (optional) 
     * @return Success
     */
    downloadDocument(id: string, documentUrl?: string | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/conversations/{id}/document/download?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (documentUrl === null)
            throw new globalThis.Error("The parameter 'documentUrl' cannot be null.");
        else if (documentUrl !== undefined)
            url_ += "documentUrl=" + encodeURIComponent("" + documentUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadDocument(_response);
        });
    }

    protected processDownloadDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get a page of the user's conversations
     * @param projectId (optional) 
     * @param cursor (optional) 
     * @param limit (optional) 
     * @param fullLoad (optional) 
     * @return Success
     */
    getConversationsPaged(projectId?: string | undefined, cursor?: string | undefined, limit?: number | undefined, fullLoad?: boolean | undefined, signal?: AbortSignal): Promise<ConversationPage> {
        let url_ = this.baseUrl + "/api/v1/conversations/paged?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (cursor === null)
            throw new globalThis.Error("The parameter 'cursor' cannot be null.");
        else if (cursor !== undefined)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (fullLoad === null)
            throw new globalThis.Error("The parameter 'fullLoad' cannot be null.");
        else if (fullLoad !== undefined)
            url_ += "fullLoad=" + encodeURIComponent("" + fullLoad) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConversationsPaged(_response);
        });
    }

    protected processGetConversationsPaged(response: AxiosResponse): Promise<ConversationPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConversationPage.fromJS(resultData200);
            
            // Log title and LastUpdateOn for each conversation in the page
            try {
                if (result200 && Array.isArray(result200.conversations)) {
                    for (const conversation of result200.conversations) {
                        const title = conversation?.title ?? conversation?.Title ?? '<no title>';
                        const rawDate = conversation?.lastUpdateOn ?? conversation?.LastUpdateOn ?? '<no LastUpdateOn>';
                        const lastUpdate = formatDateToDDMMYYYYHHMMSS(rawDate);
                        // eslint-disable-next-line no-console
                        //console.log(`Title: ${title}, LastUpdateOn: ${lastUpdate}`);
                    }
                }
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Could not log conversations', e);
            }

            return Promise.resolve<ConversationPage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversationPage>(null as any);
    }

    /**
     * Get a user's conversations filtered
     * @param searchText (optional) 
     * @param fullLoad (optional) 
     * @return Success
     */
    getConversationsFiltered(searchText?: string | undefined, fullLoad?: boolean | undefined, signal?: AbortSignal): Promise<Conversation[]> {
        let url_ = this.baseUrl + "/api/v1/conversations/filtered?";
        if (searchText === null)
            throw new globalThis.Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (fullLoad === null)
            throw new globalThis.Error("The parameter 'fullLoad' cannot be null.");
        else if (fullLoad !== undefined)
            url_ += "fullLoad=" + encodeURIComponent("" + fullLoad) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConversationsFiltered(_response);
        });
    }

    protected processGetConversationsFiltered(response: AxiosResponse): Promise<Conversation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Conversation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Conversation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Conversation[]>(null as any);
    }

    /**
     * Populate lastUpdateOn on conversations
     * @return Created
     */
    populateLastUpdateOn(signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/conversations/populatelastupdateon";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPopulateLastUpdateOn(_response);
        });
    }

    protected processPopulateLastUpdateOn(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return Promise.resolve<number>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Checks if the current user is enrolled in the AI Hub platform
     * @return Success
     */
    isUserEnrolled(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/enrollment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsUserEnrolled(_response);
        });
    }

    protected processIsUserEnrolled(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Enrolls the current user in the AI Hub platform
     * @return Success
     */
    enroll(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/enrollment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnroll(_response);
        });
    }

    protected processEnroll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Unenrolls the current user from the AI Hub platform
     * @return Success
     */
    unenroll(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/enrollment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnenroll(_response);
        });
    }

    protected processUnenroll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the configurations of all the GPTs enabled for the authenticated user
     * @param includeDefaultGpts (optional) 
     * @return Success
     */
    getGptConfigurations(includeDefaultGpts?: boolean | undefined, signal?: AbortSignal): Promise<GptConfiguration[]> {
        let url_ = this.baseUrl + "/api/v1/gpt?";
        if (includeDefaultGpts === null)
            throw new globalThis.Error("The parameter 'includeDefaultGpts' cannot be null.");
        else if (includeDefaultGpts !== undefined)
            url_ += "includeDefaultGpts=" + encodeURIComponent("" + includeDefaultGpts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGptConfigurations(_response);
        });
    }

    protected processGetGptConfigurations(response: AxiosResponse): Promise<GptConfiguration[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GptConfiguration.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GptConfiguration[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GptConfiguration[]>(null as any);
    }

    /**
     * Upsert a featured GPT configuration (e.g. SyensqoInformation type)
     * @param body (optional) 
     * @return Success
     */
    upsertFeaturedGptConfiguration(body?: GptConfiguration | undefined, signal?: AbortSignal): Promise<Conversation> {
        let url_ = this.baseUrl + "/api/v1/gpt/featured";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertFeaturedGptConfiguration(_response);
        });
    }

    protected processUpsertFeaturedGptConfiguration(response: AxiosResponse): Promise<Conversation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Conversation.fromJS(resultData200);
            return Promise.resolve<Conversation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Conversation>(null as any);
    }

    /**
     * Create a Personal GPT using the CYOT external API
     * @param name (optional) 
     * @param description (optional) 
     * @param instruction (optional) 
     * @param starters (optional) 
     * @param files (optional) 
     * @param filesToDelete (optional) 
     * @return Success
     */
    createPersonalGpt(name?: string | undefined, description?: string | undefined, instruction?: string | undefined, starters?: string[] | undefined, files?: FileParameter[] | undefined, filesToDelete?: string[] | undefined, signal?: AbortSignal): Promise<GptConfiguration> {
        let url_ = this.baseUrl + "/api/v1/gpt/personal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name === null || name === undefined)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (description === null || description === undefined)
            throw new globalThis.Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (instruction === null || instruction === undefined)
            throw new globalThis.Error("The parameter 'instruction' cannot be null.");
        else
            content_.append("Instruction", instruction.toString());
        if (starters === null || starters === undefined)
            throw new globalThis.Error("The parameter 'starters' cannot be null.");
        else
            starters.forEach(item_ => content_.append("Starters", item_.toString()));
        if (files === null || files === undefined)
            throw new globalThis.Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (filesToDelete === null || filesToDelete === undefined)
            throw new globalThis.Error("The parameter 'filesToDelete' cannot be null.");
        else
            filesToDelete.forEach(item_ => content_.append("FilesToDelete", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePersonalGpt(_response);
        });
    }

    protected processCreatePersonalGpt(response: AxiosResponse): Promise<GptConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GptConfiguration.fromJS(resultData200);
            return Promise.resolve<GptConfiguration>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GptConfiguration>(null as any);
    }

    /**
     * Get all Personal GPTs using the CYOT external API
     * @return Success
     */
    getPersonalGpts(signal?: AbortSignal): Promise<GptConfiguration[]> {
        let url_ = this.baseUrl + "/api/v1/gpt/personal";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPersonalGpts(_response);
        });
    }

    protected processGetPersonalGpts(response: AxiosResponse): Promise<GptConfiguration[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GptConfiguration.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GptConfiguration[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GptConfiguration[]>(null as any);
    }

    /**
     * Modify a Personal GPT using the CYOT external API
     * @param name (optional) 
     * @param description (optional) 
     * @param instruction (optional) 
     * @param starters (optional) 
     * @param files (optional) 
     * @param filesToDelete (optional) 
     * @return Success
     */
    modifyPersonalGpt(id: string, name?: string | undefined, description?: string | undefined, instruction?: string | undefined, starters?: string[] | undefined, files?: FileParameter[] | undefined, filesToDelete?: string[] | undefined, signal?: AbortSignal): Promise<GptConfiguration> {
        let url_ = this.baseUrl + "/api/v1/gpt/personal/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name === null || name === undefined)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (description === null || description === undefined)
            throw new globalThis.Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (instruction === null || instruction === undefined)
            throw new globalThis.Error("The parameter 'instruction' cannot be null.");
        else
            content_.append("Instruction", instruction.toString());
        if (starters === null || starters === undefined)
            throw new globalThis.Error("The parameter 'starters' cannot be null.");
        else
            starters.forEach(item_ => content_.append("Starters", item_.toString()));
        if (files === null || files === undefined)
            throw new globalThis.Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (filesToDelete === null || filesToDelete === undefined)
            throw new globalThis.Error("The parameter 'filesToDelete' cannot be null.");
        else
            filesToDelete.forEach(item_ => content_.append("FilesToDelete", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModifyPersonalGpt(_response);
        });
    }

    protected processModifyPersonalGpt(response: AxiosResponse): Promise<GptConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GptConfiguration.fromJS(resultData200);
            return Promise.resolve<GptConfiguration>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GptConfiguration>(null as any);
    }

    /**
     * Delete a Personal GPT using the CYOT external API
     * @return Success
     */
    deletePersonalGpt(id: string, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/gpt/personal/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePersonalGpt(_response);
        });
    }

    protected processDeletePersonalGpt(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get a Personal GPT model using the CYOT external API
     * @return Success
     */
    getPersonalGpt(id: string, signal?: AbortSignal): Promise<PersonalGptResponse> {
        let url_ = this.baseUrl + "/api/v1/gpt/personal/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPersonalGpt(_response);
        });
    }

    protected processGetPersonalGpt(response: AxiosResponse): Promise<PersonalGptResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PersonalGptResponse.fromJS(resultData200);
            return Promise.resolve<PersonalGptResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonalGptResponse>(null as any);
    }

    /**
     * @return Success
     */
    anonymous(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnonymous(_response);
        });
    }

    protected processAnonymous(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the terms of use from the AI Hub platform
     * @return Success
     */
    getTermsOfUse(signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/legal/terms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTermsOfUse(_response);
        });
    }

    protected processGetTermsOfUse(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get the user Quota
     * @return Success
     */
    getUserQuota(signal?: AbortSignal): Promise<Quota> {
        let url_ = this.baseUrl + "/api/v1/quota";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserQuota(_response);
        });
    }

    protected processGetUserQuota(response: AxiosResponse): Promise<Quota> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Quota.fromJS(resultData200);
            return Promise.resolve<Quota>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Quota>(null as any);
    }

    /**
     * Get the latest, active survey
     * @return Success
     */
    getLatestSurvey(signal?: AbortSignal): Promise<Survey> {
        let url_ = this.baseUrl + "/api/v1/survey/latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestSurvey(_response);
        });
    }

    protected processGetLatestSurvey(response: AxiosResponse): Promise<Survey> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Survey.fromJS(resultData200);
            return Promise.resolve<Survey>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Survey>(null as any);
    }

    /**
     * Delete latest survey
     * @return Success
     */
    deleteLatestSurvey(signal?: AbortSignal): Promise<Survey> {
        let url_ = this.baseUrl + "/api/v1/survey/latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLatestSurvey(_response);
        });
    }

    protected processDeleteLatestSurvey(response: AxiosResponse): Promise<Survey> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Survey.fromJS(resultData200);
            return Promise.resolve<Survey>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Survey>(null as any);
    }

    /**
     * Get the latest survey raw data without user filtering
     * @return Success
     */
    getLatestSurveyRaw(signal?: AbortSignal): Promise<Survey> {
        let url_ = this.baseUrl + "/api/v1/survey/latest/raw";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestSurveyRaw(_response);
        });
    }

    protected processGetLatestSurveyRaw(response: AxiosResponse): Promise<Survey> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Survey.fromJS(resultData200);
            return Promise.resolve<Survey>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Survey>(null as any);
    }

    /**
     * Get the most recent survey by id naming convention (e.g., s_202507_01)
     * @return Success
     */
    getMostRecentSurvey(signal?: AbortSignal): Promise<Survey> {
        let url_ = this.baseUrl + "/api/v1/survey/mostrecent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMostRecentSurvey(_response);
        });
    }

    protected processGetMostRecentSurvey(response: AxiosResponse): Promise<Survey> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Survey.fromJS(resultData200);
            return Promise.resolve<Survey>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Survey>(null as any);
    }

    /**
     * Upsert a survey
     * @param body (optional) 
     * @return Success
     */
    upsertSurvey(body?: Survey | undefined, signal?: AbortSignal): Promise<Survey> {
        let url_ = this.baseUrl + "/api/v1/survey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertSurvey(_response);
        });
    }

    protected processUpsertSurvey(response: AxiosResponse): Promise<Survey> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Survey.fromJS(resultData200);
            return Promise.resolve<Survey>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Survey>(null as any);
    }

    /**
     * Submit a survey response
     * @param body (optional) 
     * @return Created
     */
    submitSurveyResponse(body?: SurveyResponse | undefined, signal?: AbortSignal): Promise<SurveyResponse> {
        let url_ = this.baseUrl + "/api/v1/survey/response";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitSurveyResponse(_response);
        });
    }

    protected processSubmitSurveyResponse(response: AxiosResponse): Promise<SurveyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = SurveyResponse.fromJS(resultData201);
            return Promise.resolve<SurveyResponse>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyResponse>(null as any);
    }

    /**
     * Activate a specific survey by setting its partitionKey to 'latest'
     * @param body (optional) 
     * @return Success
     */
    activateSurvey(body?: SurveyActivationRequest | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/survey/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateSurvey(_response);
        });
    }

    protected processActivateSurvey(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Deactivate a specific survey by setting its partitionKey to 'deactivated'
     * @param body (optional) 
     * @return Success
     */
    deactivateSurvey(body?: SurveyActivationRequest | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/survey/deactivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivateSurvey(_response);
        });
    }

    protected processDeactivateSurvey(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get the current survey activation status
     * @return Success
     */
    getSurveyStatus(signal?: AbortSignal): Promise<any> {
        let url_ = this.baseUrl + "/api/v1/survey/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveyStatus(_response);
        });
    }

    protected processGetSurveyStatus(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Get the user preferences
     * @return Success
     */
    getUserPreferences(signal?: AbortSignal): Promise<UserPreferences> {
        let url_ = this.baseUrl + "/api/v1/user/preferences";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPreferences(_response);
        });
    }

    protected processGetUserPreferences(response: AxiosResponse): Promise<UserPreferences> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserPreferences.fromJS(resultData200);
            return Promise.resolve<UserPreferences>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPreferences>(null as any);
    }

    /**
     * Update the user preferences
     * @param body (optional) 
     * @return Success
     */
    updateUserPreferences(body?: UserPreferences | undefined, signal?: AbortSignal): Promise<UserPreferences> {
        let url_ = this.baseUrl + "/api/v1/user/preferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserPreferences(_response);
        });
    }

    protected processUpdateUserPreferences(response: AxiosResponse): Promise<UserPreferences> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserPreferences.fromJS(resultData200);
            return Promise.resolve<UserPreferences>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPreferences>(null as any);
    }

    /**
     * Assign the specified role to the list of users
     * @param body (optional) 
     * @return No Content
     */
    updateUsersRole(body?: UpdateUsersRoleRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/data/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUsersRole(_response);
        });
    }

    protected processUpdateUsersRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all user/role Assignments
     * @return Success
     */
    getAllUserRoleAssignments(signal?: AbortSignal): Promise<UserRoleAssignment[]> {
        let url_ = this.baseUrl + "/api/v1/user/data/userroleassignments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUserRoleAssignments(_response);
        });
    }

    protected processGetAllUserRoleAssignments(response: AxiosResponse): Promise<UserRoleAssignment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleAssignment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserRoleAssignment[]>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRoleAssignment[]>(null as any);
    }

    /**
     * Delete user data (e.g. association of a role to a certain user)
     * @return No Content
     */
    deleteUserData(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/data/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUserData(_response);
        });
    }

    protected processDeleteUserData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export enum ActionTypes {
    Message = "Message",
    RenameConversation = "RenameConversation",
    RegenerateAnswer = "RegenerateAnswer",
    Feedback = "Feedback",
}

export class Attachment implements IAttachment {
    name?: string | undefined;
    extension?: string | undefined;
    sizeMB?: number;
    extensionType?: AttachmentExtensionType;
    readonly mimeType?: string | undefined;
    sourceType?: AttachmentSourceType;

    constructor(data?: IAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.sizeMB = _data["sizeMB"];
            this.extensionType = _data["extensionType"];
            (this as any).mimeType = _data["mimeType"];
            this.sourceType = _data["sourceType"];
        }
    }

    static fromJS(data: any): Attachment {
        data = typeof data === 'object' ? data : {};
        let result = new Attachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["sizeMB"] = this.sizeMB;
        data["extensionType"] = this.extensionType;
        data["mimeType"] = this.mimeType;
        data["sourceType"] = this.sourceType;
        return data;
    }

    clone(): Attachment {
        const json = this.toJSON();
        let result = new Attachment();
        result.init(json);
        return result;
    }
}

export interface IAttachment {
    name?: string | undefined;
    extension?: string | undefined;
    sizeMB?: number;
    extensionType?: AttachmentExtensionType;
    mimeType?: string | undefined;
    sourceType?: AttachmentSourceType;
}

export class AttachmentExtension implements IAttachmentExtension {
    value?: string | undefined;
    type?: AttachmentExtensionType;
    mimeType?: string | undefined;

    constructor(data?: IAttachmentExtension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.type = _data["type"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): AttachmentExtension {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentExtension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["type"] = this.type;
        data["mimeType"] = this.mimeType;
        return data;
    }

    clone(): AttachmentExtension {
        const json = this.toJSON();
        let result = new AttachmentExtension();
        result.init(json);
        return result;
    }
}

export interface IAttachmentExtension {
    value?: string | undefined;
    type?: AttachmentExtensionType;
    mimeType?: string | undefined;
}

export enum AttachmentExtensionType {
    Document = "Document",
    Image = "Image",
    Spreadsheet = "Spreadsheet",
}

export enum AttachmentSourceType {
    LocalDrive = "LocalDrive",
    GoogleDrive = "GoogleDrive",
    AzureStorage = "AzureStorage",
}

export class ClientConfiguration implements IClientConfiguration {
    conversation?: ConversationConfiguration;
    syensqoRagGpts?: SyensqoRagGptsConfiguration;
    personalGpt?: PersonalGptConfiguration;
    speechToText?: SpeechToTextConfiguration;
    llmModels?: string[] | undefined;
    isAdmin?: boolean;

    constructor(data?: IClientConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.conversation = data.conversation && !(data.conversation as any).toJSON ? new ConversationConfiguration(data.conversation) : this.conversation as ConversationConfiguration;
            this.syensqoRagGpts = data.syensqoRagGpts && !(data.syensqoRagGpts as any).toJSON ? new SyensqoRagGptsConfiguration(data.syensqoRagGpts) : this.syensqoRagGpts as SyensqoRagGptsConfiguration;
            this.personalGpt = data.personalGpt && !(data.personalGpt as any).toJSON ? new PersonalGptConfiguration(data.personalGpt) : this.personalGpt as PersonalGptConfiguration;
            this.speechToText = data.speechToText && !(data.speechToText as any).toJSON ? new SpeechToTextConfiguration(data.speechToText) : this.speechToText as SpeechToTextConfiguration;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversation = _data["conversation"] ? ConversationConfiguration.fromJS(_data["conversation"]) : undefined as any;
            this.syensqoRagGpts = _data["syensqoRagGpts"] ? SyensqoRagGptsConfiguration.fromJS(_data["syensqoRagGpts"]) : undefined as any;
            this.personalGpt = _data["personalGpt"] ? PersonalGptConfiguration.fromJS(_data["personalGpt"]) : undefined as any;
            this.speechToText = _data["speechToText"] ? SpeechToTextConfiguration.fromJS(_data["speechToText"]) : undefined as any;
            if (Array.isArray(_data["llmModels"])) {
                this.llmModels = [] as any;
                for (let item of _data["llmModels"])
                    this.llmModels!.push(item);
            }
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): ClientConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ClientConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversation"] = this.conversation ? this.conversation.toJSON() : undefined as any;
        data["syensqoRagGpts"] = this.syensqoRagGpts ? this.syensqoRagGpts.toJSON() : undefined as any;
        data["personalGpt"] = this.personalGpt ? this.personalGpt.toJSON() : undefined as any;
        data["speechToText"] = this.speechToText ? this.speechToText.toJSON() : undefined as any;
        if (Array.isArray(this.llmModels)) {
            data["llmModels"] = [];
            for (let item of this.llmModels)
                data["llmModels"].push(item);
        }
        data["isAdmin"] = this.isAdmin;
        return data;
    }

    clone(): ClientConfiguration {
        const json = this.toJSON();
        let result = new ClientConfiguration();
        result.init(json);
        return result;
    }
}

export interface IClientConfiguration {
    conversation?: IConversationConfiguration;
    syensqoRagGpts?: ISyensqoRagGptsConfiguration;
    personalGpt?: IPersonalGptConfiguration;
    speechToText?: ISpeechToTextConfiguration;
    llmModels?: string[] | undefined;
    isAdmin?: boolean;
}

export class Conversation implements IConversation {
    gpt?: ConversationGpt;
    prompts?: Prompt[] | undefined;
    currentQuery!: string;
    startedOn!: Date;
    lastUpdateOn?: Date | undefined;
    title!: string;
    id!: string;
    userName!: string;
    userQuotaLimit?: number | undefined;
    userQuotaRemaining?: number | undefined;
    attachments?: Attachment[] | undefined;
    llm!: string;
    projectId?: string | undefined;
    fullyLoaded?: boolean | undefined;

    constructor(data?: IConversation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.gpt = data.gpt && !(data.gpt as any).toJSON ? new ConversationGpt(data.gpt) : this.gpt as ConversationGpt;
            if (data.prompts) {
                this.prompts = [];
                for (let i = 0; i < data.prompts.length; i++) {
                    let item = data.prompts[i];
                    this.prompts[i] = item && !(item as any).toJSON ? new Prompt(item) : item as Prompt;
                }
            }
            if (data.attachments) {
                this.attachments = [];
                for (let i = 0; i < data.attachments.length; i++) {
                    let item = data.attachments[i];
                    this.attachments[i] = item && !(item as any).toJSON ? new Attachment(item) : item as Attachment;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gpt = _data["gpt"] ? ConversationGpt.fromJS(_data["gpt"]) : undefined as any;
            if (Array.isArray(_data["prompts"])) {
                this.prompts = [] as any;
                for (let item of _data["prompts"])
                    this.prompts!.push(Prompt.fromJS(item));
            }
            this.currentQuery = _data["currentQuery"];
            this.startedOn = _data["startedOn"] ? new Date(_data["startedOn"].toString()) : undefined as any;
            this.lastUpdateOn = _data["lastUpdateOn"] ? new Date(_data["lastUpdateOn"].toString()) : undefined as any;
            this.title = _data["title"];
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.userQuotaLimit = _data["userQuotaLimit"];
            this.userQuotaRemaining = _data["userQuotaRemaining"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item));
            }
            this.llm = _data["llm"];
            this.projectId = _data["projectId"];
            this.fullyLoaded = _data["fullyLoaded"];
        }
    }

    static fromJS(data: any): Conversation {
        data = typeof data === 'object' ? data : {};
        let result = new Conversation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gpt"] = this.gpt ? this.gpt.toJSON() : undefined as any;
        if (Array.isArray(this.prompts)) {
            data["prompts"] = [];
            for (let item of this.prompts)
                data["prompts"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentQuery"] = this.currentQuery;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : undefined as any;
        data["lastUpdateOn"] = this.lastUpdateOn ? this.lastUpdateOn.toISOString() : undefined as any;
        data["title"] = this.title;
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["userQuotaLimit"] = this.userQuotaLimit;
        data["userQuotaRemaining"] = this.userQuotaRemaining;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["llm"] = this.llm;
        data["projectId"] = this.projectId;
        data["fullyLoaded"] = this.fullyLoaded;
        return data;
    }

    clone(): Conversation {
        const json = this.toJSON();
        let result = new Conversation();
        result.init(json);
        return result;
    }
}

export interface IConversation {
    gpt?: IConversationGpt;
    prompts?: IPrompt[] | undefined;
    currentQuery: string;
    startedOn: Date;
    lastUpdateOn?: Date | undefined;
    title: string;
    id: string;
    userName: string;
    userQuotaLimit?: number | undefined;
    userQuotaRemaining?: number | undefined;
    attachments?: IAttachment[] | undefined;
    llm: string;
    projectId?: string | undefined;
    fullyLoaded?: boolean | undefined;
}

export class ConversationConfiguration implements IConversationConfiguration {
    maxMessageLength?: number;
    maxConversationLength?: number;
    isChainOfThoughtsEnabled?: boolean;
    isUploadSurvey?: boolean;

    constructor(data?: IConversationConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxMessageLength = _data["maxMessageLength"];
            this.maxConversationLength = _data["maxConversationLength"];
            this.isChainOfThoughtsEnabled = _data["isChainOfThoughtsEnabled"];
            this.isUploadSurvey = _data["isUploadSurvey"];
        }
    }

    static fromJS(data: any): ConversationConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxMessageLength"] = this.maxMessageLength;
        data["maxConversationLength"] = this.maxConversationLength;
        data["isChainOfThoughtsEnabled"] = this.isChainOfThoughtsEnabled;
        data["isUploadSurvey"] = this.isUploadSurvey;
        return data;
    }

    clone(): ConversationConfiguration {
        const json = this.toJSON();
        let result = new ConversationConfiguration();
        result.init(json);
        return result;
    }
}

export interface IConversationConfiguration {
    maxMessageLength?: number;
    maxConversationLength?: number;
    isChainOfThoughtsEnabled?: boolean;
    isUploadSurvey?: boolean;
}

export class ConversationCreate implements IConversationCreate {
    gpt?: ConversationGpt;

    constructor(data?: IConversationCreate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.gpt = data.gpt && !(data.gpt as any).toJSON ? new ConversationGpt(data.gpt) : this.gpt as ConversationGpt;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gpt = _data["gpt"] ? ConversationGpt.fromJS(_data["gpt"]) : undefined as any;
        }
    }

    static fromJS(data: any): ConversationCreate {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gpt"] = this.gpt ? this.gpt.toJSON() : undefined as any;
        return data;
    }

    clone(): ConversationCreate {
        const json = this.toJSON();
        let result = new ConversationCreate();
        result.init(json);
        return result;
    }
}

export interface IConversationCreate {
    gpt?: IConversationGpt;
}

export class ConversationGpt implements IConversationGpt {
    type?: GptTypes;
    id?: string;

    constructor(data?: IConversationGpt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConversationGpt {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationGpt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }

    clone(): ConversationGpt {
        const json = this.toJSON();
        let result = new ConversationGpt();
        result.init(json);
        return result;
    }
}

export interface IConversationGpt {
    type?: GptTypes;
    id?: string;
}

export class ConversationPage implements IConversationPage {
    conversations?: Conversation[] | undefined;
    nextCursor?: string | undefined;

    constructor(data?: IConversationPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.conversations) {
                this.conversations = [];
                for (let i = 0; i < data.conversations.length; i++) {
                    let item = data.conversations[i];
                    this.conversations[i] = item && !(item as any).toJSON ? new Conversation(item) : item as Conversation;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conversations"])) {
                this.conversations = [] as any;
                for (let item of _data["conversations"])
                    this.conversations!.push(Conversation.fromJS(item));
            }
            this.nextCursor = _data["nextCursor"];
        }
    }

    static fromJS(data: any): ConversationPage {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conversations)) {
            data["conversations"] = [];
            for (let item of this.conversations)
                data["conversations"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextCursor"] = this.nextCursor;
        return data;
    }

    clone(): ConversationPage {
        const json = this.toJSON();
        let result = new ConversationPage();
        result.init(json);
        return result;
    }
}

export interface IConversationPage {
    conversations?: IConversation[] | undefined;
    nextCursor?: string | undefined;
}

export class ConversationPatch implements IConversationPatch {
    currentQuery?: string | undefined;
    currentPlugins?: string[] | undefined;
    currentPromptFeedbackIndex?: number | undefined;
    title?: string | undefined;
    prompts?: Prompt[] | undefined;
    attachments?: Attachment[] | undefined;
    actionType?: ActionTypes;
    llmDeploymentName?: string | undefined;
    projectId?: string | undefined;
    reasoningLevel?: string | undefined;

    constructor(data?: IConversationPatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.prompts) {
                this.prompts = [];
                for (let i = 0; i < data.prompts.length; i++) {
                    let item = data.prompts[i];
                    this.prompts[i] = item && !(item as any).toJSON ? new Prompt(item) : item as Prompt;
                }
            }
            if (data.attachments) {
                this.attachments = [];
                for (let i = 0; i < data.attachments.length; i++) {
                    let item = data.attachments[i];
                    this.attachments[i] = item && !(item as any).toJSON ? new Attachment(item) : item as Attachment;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentQuery = _data["currentQuery"];
            if (Array.isArray(_data["currentPlugins"])) {
                this.currentPlugins = [] as any;
                for (let item of _data["currentPlugins"])
                    this.currentPlugins!.push(item);
            }
            this.currentPromptFeedbackIndex = _data["currentPromptFeedbackIndex"];
            this.title = _data["title"];
            if (Array.isArray(_data["prompts"])) {
                this.prompts = [] as any;
                for (let item of _data["prompts"])
                    this.prompts!.push(Prompt.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item));
            }
            this.actionType = _data["actionType"];
            this.llmDeploymentName = _data["llmDeploymentName"];
            this.projectId = _data["projectId"];
            this.reasoningLevel = _data["reasoningLevel"];
        }
    }

    static fromJS(data: any): ConversationPatch {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationPatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentQuery"] = this.currentQuery;
        if (Array.isArray(this.currentPlugins)) {
            data["currentPlugins"] = [];
            for (let item of this.currentPlugins)
                data["currentPlugins"].push(item);
        }
        data["currentPromptFeedbackIndex"] = this.currentPromptFeedbackIndex;
        data["title"] = this.title;
        if (Array.isArray(this.prompts)) {
            data["prompts"] = [];
            for (let item of this.prompts)
                data["prompts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["actionType"] = this.actionType;
        data["llmDeploymentName"] = this.llmDeploymentName;
        data["projectId"] = this.projectId;
        data["reasoningLevel"] = this.reasoningLevel;
        return data;
    }

    clone(): ConversationPatch {
        const json = this.toJSON();
        let result = new ConversationPatch();
        result.init(json);
        return result;
    }
}

export interface IConversationPatch {
    currentQuery?: string | undefined;
    currentPlugins?: string[] | undefined;
    currentPromptFeedbackIndex?: number | undefined;
    title?: string | undefined;
    prompts?: IPrompt[] | undefined;
    attachments?: IAttachment[] | undefined;
    actionType?: ActionTypes;
    llmDeploymentName?: string | undefined;
    projectId?: string | undefined;
    reasoningLevel?: string | undefined;
}

export class ConversationStarter implements IConversationStarter {
    name?: string | undefined;
    description?: string | undefined;
    startingPrompt?: string | undefined;
    icon?: string | undefined;

    constructor(data?: IConversationStarter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.startingPrompt = _data["startingPrompt"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): ConversationStarter {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationStarter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["startingPrompt"] = this.startingPrompt;
        data["icon"] = this.icon;
        return data;
    }

    clone(): ConversationStarter {
        const json = this.toJSON();
        let result = new ConversationStarter();
        result.init(json);
        return result;
    }
}

export interface IConversationStarter {
    name?: string | undefined;
    description?: string | undefined;
    startingPrompt?: string | undefined;
    icon?: string | undefined;
}

export class FeatureHighlights implements IFeatureHighlights {
    documentUpload?: boolean;
    syGPTTool3C?: boolean;
    excelAssistant?: boolean;
    multipleDocumentUpload?: boolean;
    mainHighLights?: boolean;

    constructor(data?: IFeatureHighlights) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentUpload = _data["documentUpload"];
            this.syGPTTool3C = _data["syGPTTool3C"];
            this.excelAssistant = _data["excelAssistant"];
            this.multipleDocumentUpload = _data["multipleDocumentUpload"];
            this.mainHighLights = _data["mainHighLights"];
        }
    }

    static fromJS(data: any): FeatureHighlights {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureHighlights();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentUpload"] = this.documentUpload;
        data["syGPTTool3C"] = this.syGPTTool3C;
        data["excelAssistant"] = this.excelAssistant;
        data["multipleDocumentUpload"] = this.multipleDocumentUpload;
        data["mainHighLights"] = this.mainHighLights;
        return data;
    }

    clone(): FeatureHighlights {
        const json = this.toJSON();
        let result = new FeatureHighlights();
        result.init(json);
        return result;
    }
}

export interface IFeatureHighlights {
    documentUpload?: boolean;
    syGPTTool3C?: boolean;
    excelAssistant?: boolean;
    multipleDocumentUpload?: boolean;
    mainHighLights?: boolean;
}

export class Feedback implements IFeedback {
    positive!: boolean;
    comment?: string | undefined;
    isNotHelpful?: boolean | undefined;
    isNotTrue?: boolean | undefined;
    isHarmfullUnsafe?: boolean | undefined;

    constructor(data?: IFeedback) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.positive = _data["positive"];
            this.comment = _data["comment"];
            this.isNotHelpful = _data["isNotHelpful"];
            this.isNotTrue = _data["isNotTrue"];
            this.isHarmfullUnsafe = _data["isHarmfullUnsafe"];
        }
    }

    static fromJS(data: any): Feedback {
        data = typeof data === 'object' ? data : {};
        let result = new Feedback();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positive"] = this.positive;
        data["comment"] = this.comment;
        data["isNotHelpful"] = this.isNotHelpful;
        data["isNotTrue"] = this.isNotTrue;
        data["isHarmfullUnsafe"] = this.isHarmfullUnsafe;
        return data;
    }

    clone(): Feedback {
        const json = this.toJSON();
        let result = new Feedback();
        result.init(json);
        return result;
    }
}

export interface IFeedback {
    positive: boolean;
    comment?: string | undefined;
    isNotHelpful?: boolean | undefined;
    isNotTrue?: boolean | undefined;
    isHarmfullUnsafe?: boolean | undefined;
}

export class GptAttachmentConfiguration implements IGptAttachmentConfiguration {
    isEnabled?: boolean;
    maxFiles?: number | undefined;
    maxTotalFilesSizeMB?: number | undefined;
    maxSizeMB?: number | undefined;
    extensions?: AttachmentExtension[] | undefined;

    constructor(data?: IGptAttachmentConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.extensions) {
                this.extensions = [];
                for (let i = 0; i < data.extensions.length; i++) {
                    let item = data.extensions[i];
                    this.extensions[i] = item && !(item as any).toJSON ? new AttachmentExtension(item) : item as AttachmentExtension;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.maxFiles = _data["maxFiles"];
            this.maxTotalFilesSizeMB = _data["maxTotalFilesSizeMB"];
            this.maxSizeMB = _data["maxSizeMB"];
            if (Array.isArray(_data["extensions"])) {
                this.extensions = [] as any;
                for (let item of _data["extensions"])
                    this.extensions!.push(AttachmentExtension.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GptAttachmentConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new GptAttachmentConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFiles"] = this.maxFiles;
        data["maxTotalFilesSizeMB"] = this.maxTotalFilesSizeMB;
        data["maxSizeMB"] = this.maxSizeMB;
        if (Array.isArray(this.extensions)) {
            data["extensions"] = [];
            for (let item of this.extensions)
                data["extensions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): GptAttachmentConfiguration {
        const json = this.toJSON();
        let result = new GptAttachmentConfiguration();
        result.init(json);
        return result;
    }
}

export interface IGptAttachmentConfiguration {
    isEnabled?: boolean;
    maxFiles?: number | undefined;
    maxTotalFilesSizeMB?: number | undefined;
    maxSizeMB?: number | undefined;
    extensions?: IAttachmentExtension[] | undefined;
}

export class GptConfiguration implements IGptConfiguration {
    id?: string;
    isEnabled?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    isDefault?: boolean;
    type?: GptTypes;
    ragIsletName?: string | undefined;
    readonly isPersonal?: boolean;
    disclaimer?: string | undefined;
    prompt?: string | undefined;
    icon?: string | undefined;
    conversationStarters?: ConversationStarter[] | undefined;
    attachment?: GptAttachmentConfiguration;
    plugins?: GptPluginConfiguration[] | undefined;
    status?: GptStatus;
    createdOn?: Date;
    lastUpdateOn?: Date | undefined;

    constructor(data?: IGptConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.conversationStarters) {
                this.conversationStarters = [];
                for (let i = 0; i < data.conversationStarters.length; i++) {
                    let item = data.conversationStarters[i];
                    this.conversationStarters[i] = item && !(item as any).toJSON ? new ConversationStarter(item) : item as ConversationStarter;
                }
            }
            this.attachment = data.attachment && !(data.attachment as any).toJSON ? new GptAttachmentConfiguration(data.attachment) : this.attachment as GptAttachmentConfiguration;
            if (data.plugins) {
                this.plugins = [];
                for (let i = 0; i < data.plugins.length; i++) {
                    let item = data.plugins[i];
                    this.plugins[i] = item && !(item as any).toJSON ? new GptPluginConfiguration(item) : item as GptPluginConfiguration;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isEnabled = _data["isEnabled"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDefault = _data["isDefault"];
            this.type = _data["type"];
            this.ragIsletName = _data["ragIsletName"];
            (this as any).isPersonal = _data["isPersonal"];
            this.disclaimer = _data["disclaimer"];
            this.prompt = _data["prompt"];
            this.icon = _data["icon"];
            if (Array.isArray(_data["conversationStarters"])) {
                this.conversationStarters = [] as any;
                for (let item of _data["conversationStarters"])
                    this.conversationStarters!.push(ConversationStarter.fromJS(item));
            }
            this.attachment = _data["attachment"] ? GptAttachmentConfiguration.fromJS(_data["attachment"]) : undefined as any;
            if (Array.isArray(_data["plugins"])) {
                this.plugins = [] as any;
                for (let item of _data["plugins"])
                    this.plugins!.push(GptPluginConfiguration.fromJS(item));
            }
            this.status = _data["status"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.lastUpdateOn = _data["lastUpdateOn"] ? new Date(_data["lastUpdateOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GptConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new GptConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isEnabled"] = this.isEnabled;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDefault"] = this.isDefault;
        data["type"] = this.type;
        data["ragIsletName"] = this.ragIsletName;
        data["isPersonal"] = this.isPersonal;
        data["disclaimer"] = this.disclaimer;
        data["prompt"] = this.prompt;
        data["icon"] = this.icon;
        if (Array.isArray(this.conversationStarters)) {
            data["conversationStarters"] = [];
            for (let item of this.conversationStarters)
                data["conversationStarters"].push(item ? item.toJSON() : undefined as any);
        }
        data["attachment"] = this.attachment ? this.attachment.toJSON() : undefined as any;
        if (Array.isArray(this.plugins)) {
            data["plugins"] = [];
            for (let item of this.plugins)
                data["plugins"].push(item ? item.toJSON() : undefined as any);
        }
        data["status"] = this.status;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["lastUpdateOn"] = this.lastUpdateOn ? this.lastUpdateOn.toISOString() : undefined as any;
        return data;
    }

    clone(): GptConfiguration {
        const json = this.toJSON();
        let result = new GptConfiguration();
        result.init(json);
        return result;
    }
}

export interface IGptConfiguration {
    id?: string;
    isEnabled?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    isDefault?: boolean;
    type?: GptTypes;
    ragIsletName?: string | undefined;
    isPersonal?: boolean;
    disclaimer?: string | undefined;
    prompt?: string | undefined;
    icon?: string | undefined;
    conversationStarters?: IConversationStarter[] | undefined;
    attachment?: IGptAttachmentConfiguration;
    plugins?: IGptPluginConfiguration[] | undefined;
    status?: GptStatus;
    createdOn?: Date;
    lastUpdateOn?: Date | undefined;
}

export class GptPluginConfiguration implements IGptPluginConfiguration {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IGptPluginConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GptPluginConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new GptPluginConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): GptPluginConfiguration {
        const json = this.toJSON();
        let result = new GptPluginConfiguration();
        result.init(json);
        return result;
    }
}

export interface IGptPluginConfiguration {
    id?: string | undefined;
    name?: string | undefined;
}

export enum GptStatus {
    Ready = "Ready",
    Running = "Running",
    Error = "Error",
}

export enum GptTypes {
    SyGpt = "SyGpt",
    SyensqoInformationGpt = "SyensqoInformationGpt",
    PersonalGpt = "PersonalGpt",
    ImageGenerationGpt = "ImageGenerationGpt",
}

export class PersonalGptConfiguration implements IPersonalGptConfiguration {
    isEnabled?: boolean;
    maxNumberOfGpts?: number;
    attachmentConfiguration?: GptAttachmentConfiguration;
    knowledgeBase?: GptAttachmentConfiguration;

    constructor(data?: IPersonalGptConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.attachmentConfiguration = data.attachmentConfiguration && !(data.attachmentConfiguration as any).toJSON ? new GptAttachmentConfiguration(data.attachmentConfiguration) : this.attachmentConfiguration as GptAttachmentConfiguration;
            this.knowledgeBase = data.knowledgeBase && !(data.knowledgeBase as any).toJSON ? new GptAttachmentConfiguration(data.knowledgeBase) : this.knowledgeBase as GptAttachmentConfiguration;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.maxNumberOfGpts = _data["maxNumberOfGpts"];
            this.attachmentConfiguration = _data["attachmentConfiguration"] ? GptAttachmentConfiguration.fromJS(_data["attachmentConfiguration"]) : undefined as any;
            this.knowledgeBase = _data["knowledgeBase"] ? GptAttachmentConfiguration.fromJS(_data["knowledgeBase"]) : undefined as any;
        }
    }

    static fromJS(data: any): PersonalGptConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalGptConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxNumberOfGpts"] = this.maxNumberOfGpts;
        data["attachmentConfiguration"] = this.attachmentConfiguration ? this.attachmentConfiguration.toJSON() : undefined as any;
        data["knowledgeBase"] = this.knowledgeBase ? this.knowledgeBase.toJSON() : undefined as any;
        return data;
    }

    clone(): PersonalGptConfiguration {
        const json = this.toJSON();
        let result = new PersonalGptConfiguration();
        result.init(json);
        return result;
    }
}

export interface IPersonalGptConfiguration {
    isEnabled?: boolean;
    maxNumberOfGpts?: number;
    attachmentConfiguration?: IGptAttachmentConfiguration;
    knowledgeBase?: IGptAttachmentConfiguration;
}

export class PersonalGptResponse implements IPersonalGptResponse {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    instruction?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    status?: string | undefined;
    files?: string[] | undefined;
    filesStatus?: StringStringTuple[] | undefined;

    constructor(data?: IPersonalGptResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.filesStatus) {
                this.filesStatus = [];
                for (let i = 0; i < data.filesStatus.length; i++) {
                    let item = data.filesStatus[i];
                    this.filesStatus[i] = item && !(item as any).toJSON ? new StringStringTuple(item) : item as StringStringTuple;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.instruction = _data["instruction"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.status = _data["status"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(item);
            }
            if (Array.isArray(_data["filesStatus"])) {
                this.filesStatus = [] as any;
                for (let item of _data["filesStatus"])
                    this.filesStatus!.push(StringStringTuple.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PersonalGptResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalGptResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["instruction"] = this.instruction;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["status"] = this.status;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        if (Array.isArray(this.filesStatus)) {
            data["filesStatus"] = [];
            for (let item of this.filesStatus)
                data["filesStatus"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PersonalGptResponse {
        const json = this.toJSON();
        let result = new PersonalGptResponse();
        result.init(json);
        return result;
    }
}

export interface IPersonalGptResponse {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    instruction?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    status?: string | undefined;
    files?: string[] | undefined;
    filesStatus?: IStringStringTuple[] | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class Prompt implements IPrompt {
    id?: string;
    query!: string;
    answer?: string | undefined;
    regeneratedAnswers?: RegeneratedAnswer[] | undefined;
    queryOn!: Date;
    answerOn?: Date | undefined;
    feedback?: Feedback;
    sources?: Source[] | undefined;
    plugins?: string[] | undefined;
    chainOfThoughts?: string[] | undefined;
    answerAttachments?: Attachment[] | undefined;

    constructor(data?: IPrompt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.regeneratedAnswers) {
                this.regeneratedAnswers = [];
                for (let i = 0; i < data.regeneratedAnswers.length; i++) {
                    let item = data.regeneratedAnswers[i];
                    this.regeneratedAnswers[i] = item && !(item as any).toJSON ? new RegeneratedAnswer(item) : item as RegeneratedAnswer;
                }
            }
            this.feedback = data.feedback && !(data.feedback as any).toJSON ? new Feedback(data.feedback) : this.feedback as Feedback;
            if (data.sources) {
                this.sources = [];
                for (let i = 0; i < data.sources.length; i++) {
                    let item = data.sources[i];
                    this.sources[i] = item && !(item as any).toJSON ? new Source(item) : item as Source;
                }
            }
            if (data.answerAttachments) {
                this.answerAttachments = [];
                for (let i = 0; i < data.answerAttachments.length; i++) {
                    let item = data.answerAttachments[i];
                    this.answerAttachments[i] = item && !(item as any).toJSON ? new Attachment(item) : item as Attachment;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.query = _data["query"];
            this.answer = _data["answer"];
            if (Array.isArray(_data["regeneratedAnswers"])) {
                this.regeneratedAnswers = [] as any;
                for (let item of _data["regeneratedAnswers"])
                    this.regeneratedAnswers!.push(RegeneratedAnswer.fromJS(item));
            }
            this.queryOn = _data["queryOn"] ? new Date(_data["queryOn"].toString()) : undefined as any;
            this.answerOn = _data["answerOn"] ? new Date(_data["answerOn"].toString()) : undefined as any;
            this.feedback = _data["feedback"] ? Feedback.fromJS(_data["feedback"]) : undefined as any;
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(Source.fromJS(item));
            }
            if (Array.isArray(_data["plugins"])) {
                this.plugins = [] as any;
                for (let item of _data["plugins"])
                    this.plugins!.push(item);
            }
            if (Array.isArray(_data["chainOfThoughts"])) {
                this.chainOfThoughts = [] as any;
                for (let item of _data["chainOfThoughts"])
                    this.chainOfThoughts!.push(item);
            }
            if (Array.isArray(_data["answerAttachments"])) {
                this.answerAttachments = [] as any;
                for (let item of _data["answerAttachments"])
                    this.answerAttachments!.push(Attachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Prompt {
        data = typeof data === 'object' ? data : {};
        let result = new Prompt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["query"] = this.query;
        data["answer"] = this.answer;
        if (Array.isArray(this.regeneratedAnswers)) {
            data["regeneratedAnswers"] = [];
            for (let item of this.regeneratedAnswers)
                data["regeneratedAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        data["queryOn"] = this.queryOn ? this.queryOn.toISOString() : undefined as any;
        data["answerOn"] = this.answerOn ? this.answerOn.toISOString() : undefined as any;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : undefined as any;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.plugins)) {
            data["plugins"] = [];
            for (let item of this.plugins)
                data["plugins"].push(item);
        }
        if (Array.isArray(this.chainOfThoughts)) {
            data["chainOfThoughts"] = [];
            for (let item of this.chainOfThoughts)
                data["chainOfThoughts"].push(item);
        }
        if (Array.isArray(this.answerAttachments)) {
            data["answerAttachments"] = [];
            for (let item of this.answerAttachments)
                data["answerAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): Prompt {
        const json = this.toJSON();
        let result = new Prompt();
        result.init(json);
        return result;
    }
}

export interface IPrompt {
    id?: string;
    query: string;
    answer?: string | undefined;
    regeneratedAnswers?: IRegeneratedAnswer[] | undefined;
    queryOn: Date;
    answerOn?: Date | undefined;
    feedback?: IFeedback;
    sources?: ISource[] | undefined;
    plugins?: string[] | undefined;
    chainOfThoughts?: string[] | undefined;
    answerAttachments?: IAttachment[] | undefined;
}

export class Question implements IQuestion {
    id?: string | undefined;
    type?: SurveyAnswerType;
    text?: string | undefined;
    isMandatory?: boolean;
    answerOptions?: string[] | undefined;

    constructor(data?: IQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.text = _data["text"];
            this.isMandatory = _data["isMandatory"];
            if (Array.isArray(_data["answerOptions"])) {
                this.answerOptions = [] as any;
                for (let item of _data["answerOptions"])
                    this.answerOptions!.push(item);
            }
        }
    }

    static fromJS(data: any): Question {
        data = typeof data === 'object' ? data : {};
        let result = new Question();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["text"] = this.text;
        data["isMandatory"] = this.isMandatory;
        if (Array.isArray(this.answerOptions)) {
            data["answerOptions"] = [];
            for (let item of this.answerOptions)
                data["answerOptions"].push(item);
        }
        return data;
    }

    clone(): Question {
        const json = this.toJSON();
        let result = new Question();
        result.init(json);
        return result;
    }
}

export interface IQuestion {
    id?: string | undefined;
    type?: SurveyAnswerType;
    text?: string | undefined;
    isMandatory?: boolean;
    answerOptions?: string[] | undefined;
}

export class Quota implements IQuota {
    renewalPeriodInMinutes?: number;
    tokenQuotaPerPeriod?: number;
    tokensLeftInPeriod?: number;
    minutesLeftBeforeRenewal?: number;

    constructor(data?: IQuota) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.renewalPeriodInMinutes = _data["renewalPeriodInMinutes"];
            this.tokenQuotaPerPeriod = _data["tokenQuotaPerPeriod"];
            this.tokensLeftInPeriod = _data["tokensLeftInPeriod"];
            this.minutesLeftBeforeRenewal = _data["minutesLeftBeforeRenewal"];
        }
    }

    static fromJS(data: any): Quota {
        data = typeof data === 'object' ? data : {};
        let result = new Quota();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renewalPeriodInMinutes"] = this.renewalPeriodInMinutes;
        data["tokenQuotaPerPeriod"] = this.tokenQuotaPerPeriod;
        data["tokensLeftInPeriod"] = this.tokensLeftInPeriod;
        data["minutesLeftBeforeRenewal"] = this.minutesLeftBeforeRenewal;
        return data;
    }

    clone(): Quota {
        const json = this.toJSON();
        let result = new Quota();
        result.init(json);
        return result;
    }
}

export interface IQuota {
    renewalPeriodInMinutes?: number;
    tokenQuotaPerPeriod?: number;
    tokensLeftInPeriod?: number;
    minutesLeftBeforeRenewal?: number;
}

export class RegeneratedAnswer implements IRegeneratedAnswer {
    answer?: string | undefined;
    attachments?: Attachment[] | undefined;

    constructor(data?: IRegeneratedAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.attachments) {
                this.attachments = [];
                for (let i = 0; i < data.attachments.length; i++) {
                    let item = data.attachments[i];
                    this.attachments[i] = item && !(item as any).toJSON ? new Attachment(item) : item as Attachment;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answer = _data["answer"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegeneratedAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new RegeneratedAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): RegeneratedAnswer {
        const json = this.toJSON();
        let result = new RegeneratedAnswer();
        result.init(json);
        return result;
    }
}

export interface IRegeneratedAnswer {
    answer?: string | undefined;
    attachments?: IAttachment[] | undefined;
}

export class Source implements ISource {
    url?: string | undefined;
    title?: string | undefined;
    pageNumber?: string | undefined;
    fileName?: string | undefined;
    webSiteUrl?: string | undefined;
    chunk?: string | undefined;
    chunkId?: string | undefined;

    constructor(data?: ISource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.title = _data["title"];
            this.pageNumber = _data["pageNumber"];
            this.fileName = _data["fileName"];
            this.webSiteUrl = _data["webSiteUrl"];
            this.chunk = _data["chunk"];
            this.chunkId = _data["chunkId"];
        }
    }

    static fromJS(data: any): Source {
        data = typeof data === 'object' ? data : {};
        let result = new Source();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["title"] = this.title;
        data["pageNumber"] = this.pageNumber;
        data["fileName"] = this.fileName;
        data["webSiteUrl"] = this.webSiteUrl;
        data["chunk"] = this.chunk;
        data["chunkId"] = this.chunkId;
        return data;
    }

    clone(): Source {
        const json = this.toJSON();
        let result = new Source();
        result.init(json);
        return result;
    }
}

export interface ISource {
    url?: string | undefined;
    title?: string | undefined;
    pageNumber?: string | undefined;
    fileName?: string | undefined;
    webSiteUrl?: string | undefined;
    chunk?: string | undefined;
    chunkId?: string | undefined;
}

export class SpeechServiceToken implements ISpeechServiceToken {
    token?: string | undefined;
    expiresOn?: Date;

    constructor(data?: ISpeechServiceToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SpeechServiceToken {
        data = typeof data === 'object' ? data : {};
        let result = new SpeechServiceToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : undefined as any;
        return data;
    }

    clone(): SpeechServiceToken {
        const json = this.toJSON();
        let result = new SpeechServiceToken();
        result.init(json);
        return result;
    }
}

export interface ISpeechServiceToken {
    token?: string | undefined;
    expiresOn?: Date;
}

export class SpeechToTextConfiguration implements ISpeechToTextConfiguration {
    isEnabled?: boolean;
    resourceId?: string | undefined;
    region?: string | undefined;
    languages?: SpeechToTextLanguage[] | undefined;
    silenceTimeout?: number;

    constructor(data?: ISpeechToTextConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.languages) {
                this.languages = [];
                for (let i = 0; i < data.languages.length; i++) {
                    let item = data.languages[i];
                    this.languages[i] = item && !(item as any).toJSON ? new SpeechToTextLanguage(item) : item as SpeechToTextLanguage;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.resourceId = _data["resourceId"];
            this.region = _data["region"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(SpeechToTextLanguage.fromJS(item));
            }
            this.silenceTimeout = _data["silenceTimeout"];
        }
    }

    static fromJS(data: any): SpeechToTextConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new SpeechToTextConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["resourceId"] = this.resourceId;
        data["region"] = this.region;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["silenceTimeout"] = this.silenceTimeout;
        return data;
    }

    clone(): SpeechToTextConfiguration {
        const json = this.toJSON();
        let result = new SpeechToTextConfiguration();
        result.init(json);
        return result;
    }
}

export interface ISpeechToTextConfiguration {
    isEnabled?: boolean;
    resourceId?: string | undefined;
    region?: string | undefined;
    languages?: ISpeechToTextLanguage[] | undefined;
    silenceTimeout?: number;
}

export class SpeechToTextLanguage implements ISpeechToTextLanguage {
    locale?: string | undefined;
    language?: string | undefined;
    shortDisplayLanguage?: string | undefined;
    displayLanguage?: string | undefined;
    customSpeechModelEndpointId?: string | undefined;

    constructor(data?: ISpeechToTextLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.language = _data["language"];
            this.shortDisplayLanguage = _data["shortDisplayLanguage"];
            this.displayLanguage = _data["displayLanguage"];
            this.customSpeechModelEndpointId = _data["customSpeechModelEndpointId"];
        }
    }

    static fromJS(data: any): SpeechToTextLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new SpeechToTextLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["language"] = this.language;
        data["shortDisplayLanguage"] = this.shortDisplayLanguage;
        data["displayLanguage"] = this.displayLanguage;
        data["customSpeechModelEndpointId"] = this.customSpeechModelEndpointId;
        return data;
    }

    clone(): SpeechToTextLanguage {
        const json = this.toJSON();
        let result = new SpeechToTextLanguage();
        result.init(json);
        return result;
    }
}

export interface ISpeechToTextLanguage {
    locale?: string | undefined;
    language?: string | undefined;
    shortDisplayLanguage?: string | undefined;
    displayLanguage?: string | undefined;
    customSpeechModelEndpointId?: string | undefined;
}

export class StringStringTuple implements IStringStringTuple {
    item1?: string | undefined;
    item2?: string | undefined;

    constructor(data?: IStringStringTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"];
            this.item2 = _data["item2"];
        }
    }

    static fromJS(data: any): StringStringTuple {
        data = typeof data === 'object' ? data : {};
        let result = new StringStringTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        return data;
    }

    clone(): StringStringTuple {
        const json = this.toJSON();
        let result = new StringStringTuple();
        result.init(json);
        return result;
    }
}

export interface IStringStringTuple {
    item1?: string | undefined;
    item2?: string | undefined;
}

export class Survey implements ISurvey {
    id?: string | undefined;
    version?: string | undefined;
    title?: string | undefined;
    subtitle?: string | undefined;
    questions?: Question[] | undefined;

    constructor(data?: ISurvey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.questions) {
                this.questions = [];
                for (let i = 0; i < data.questions.length; i++) {
                    let item = data.questions[i];
                    this.questions[i] = item && !(item as any).toJSON ? new Question(item) : item as Question;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"];
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(Question.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Survey {
        data = typeof data === 'object' ? data : {};
        let result = new Survey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): Survey {
        const json = this.toJSON();
        let result = new Survey();
        result.init(json);
        return result;
    }
}

export interface ISurvey {
    id?: string | undefined;
    version?: string | undefined;
    title?: string | undefined;
    subtitle?: string | undefined;
    questions?: IQuestion[] | undefined;
}

export class SurveyActivationRequest implements ISurveyActivationRequest {
    surveyId?: string | undefined;

    constructor(data?: ISurveyActivationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
        }
    }

    static fromJS(data: any): SurveyActivationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyActivationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        return data;
    }

    clone(): SurveyActivationRequest {
        const json = this.toJSON();
        let result = new SurveyActivationRequest();
        result.init(json);
        return result;
    }
}

export interface ISurveyActivationRequest {
    surveyId?: string | undefined;
}

export class SurveyAnswer implements ISurveyAnswer {
    id?: string | undefined;
    value?: string | undefined;
    type?: SurveyAnswerType;

    constructor(data?: ISurveyAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SurveyAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["type"] = this.type;
        return data;
    }

    clone(): SurveyAnswer {
        const json = this.toJSON();
        let result = new SurveyAnswer();
        result.init(json);
        return result;
    }
}

export interface ISurveyAnswer {
    id?: string | undefined;
    value?: string | undefined;
    type?: SurveyAnswerType;
}

export enum SurveyAnswerType {
    Text = "Text",
    SingleValue = "SingleValue",
    Rating = "Rating",
}

export class SurveyResponse implements ISurveyResponse {
    surveyId?: string | undefined;
    surveyResponseId?: string | undefined;
    answers?: SurveyAnswer[] | undefined;

    constructor(data?: ISurveyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.answers) {
                this.answers = [];
                for (let i = 0; i < data.answers.length; i++) {
                    let item = data.answers[i];
                    this.answers[i] = item && !(item as any).toJSON ? new SurveyAnswer(item) : item as SurveyAnswer;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.surveyResponseId = _data["surveyResponseId"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(SurveyAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["surveyResponseId"] = this.surveyResponseId;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): SurveyResponse {
        const json = this.toJSON();
        let result = new SurveyResponse();
        result.init(json);
        return result;
    }
}

export interface ISurveyResponse {
    surveyId?: string | undefined;
    surveyResponseId?: string | undefined;
    answers?: ISurveyAnswer[] | undefined;
}

export class SyensqoRagGptsConfiguration implements ISyensqoRagGptsConfiguration {
    accessibleSyensqoGptIds?: string[] | undefined;
    attachmentConfiguration?: GptAttachmentConfiguration;

    constructor(data?: ISyensqoRagGptsConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.attachmentConfiguration = data.attachmentConfiguration && !(data.attachmentConfiguration as any).toJSON ? new GptAttachmentConfiguration(data.attachmentConfiguration) : this.attachmentConfiguration as GptAttachmentConfiguration;
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessibleSyensqoGptIds"])) {
                this.accessibleSyensqoGptIds = [] as any;
                for (let item of _data["accessibleSyensqoGptIds"])
                    this.accessibleSyensqoGptIds!.push(item);
            }
            this.attachmentConfiguration = _data["attachmentConfiguration"] ? GptAttachmentConfiguration.fromJS(_data["attachmentConfiguration"]) : undefined as any;
        }
    }

    static fromJS(data: any): SyensqoRagGptsConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new SyensqoRagGptsConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessibleSyensqoGptIds)) {
            data["accessibleSyensqoGptIds"] = [];
            for (let item of this.accessibleSyensqoGptIds)
                data["accessibleSyensqoGptIds"].push(item);
        }
        data["attachmentConfiguration"] = this.attachmentConfiguration ? this.attachmentConfiguration.toJSON() : undefined as any;
        return data;
    }

    clone(): SyensqoRagGptsConfiguration {
        const json = this.toJSON();
        let result = new SyensqoRagGptsConfiguration();
        result.init(json);
        return result;
    }
}

export interface ISyensqoRagGptsConfiguration {
    accessibleSyensqoGptIds?: string[] | undefined;
    attachmentConfiguration?: IGptAttachmentConfiguration;
}

export class UpdateUsersRoleRequest implements IUpdateUsersRoleRequest {
    users?: string[] | undefined;
    role?: string | undefined;

    constructor(data?: IUpdateUsersRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(item);
            }
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): UpdateUsersRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUsersRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item);
        }
        data["role"] = this.role;
        return data;
    }

    clone(): UpdateUsersRoleRequest {
        const json = this.toJSON();
        let result = new UpdateUsersRoleRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateUsersRoleRequest {
    users?: string[] | undefined;
    role?: string | undefined;
}

export class UserPreferences implements IUserPreferences {
    featureHighlights?: FeatureHighlights;
    addedGpts?: string[] | undefined;
    pinnedConversations?: string[] | undefined;
    speechToTextLanguage?: string | undefined;
    speechClickSend?: boolean | undefined;
    speechAutoSendNumSecs?: number | undefined;
    showLanguageSelectionInPrompt?: boolean | undefined;

    constructor(data?: IUserPreferences) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.featureHighlights = data.featureHighlights && !(data.featureHighlights as any).toJSON ? new FeatureHighlights(data.featureHighlights) : this.featureHighlights as FeatureHighlights;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureHighlights = _data["featureHighlights"] ? FeatureHighlights.fromJS(_data["featureHighlights"]) : undefined as any;
            if (Array.isArray(_data["addedGpts"])) {
                this.addedGpts = [] as any;
                for (let item of _data["addedGpts"])
                    this.addedGpts!.push(item);
            }
            if (Array.isArray(_data["pinnedConversations"])) {
                this.pinnedConversations = [] as any;
                for (let item of _data["pinnedConversations"])
                    this.pinnedConversations!.push(item);
            }
            this.speechToTextLanguage = _data["speechToTextLanguage"];
            this.speechClickSend = _data["speechClickSend"];
            this.speechAutoSendNumSecs = _data["speechAutoSendNumSecs"];
            this.showLanguageSelectionInPrompt = _data["showLanguageSelectionInPrompt"];
        }
    }

    static fromJS(data: any): UserPreferences {
        data = typeof data === 'object' ? data : {};
        let result = new UserPreferences();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureHighlights"] = this.featureHighlights ? this.featureHighlights.toJSON() : undefined as any;
        if (Array.isArray(this.addedGpts)) {
            data["addedGpts"] = [];
            for (let item of this.addedGpts)
                data["addedGpts"].push(item);
        }
        if (Array.isArray(this.pinnedConversations)) {
            data["pinnedConversations"] = [];
            for (let item of this.pinnedConversations)
                data["pinnedConversations"].push(item);
        }
        data["speechToTextLanguage"] = this.speechToTextLanguage;
        data["speechClickSend"] = this.speechClickSend;
        data["speechAutoSendNumSecs"] = this.speechAutoSendNumSecs;
        data["showLanguageSelectionInPrompt"] = this.showLanguageSelectionInPrompt;
        return data;
    }

    clone(): UserPreferences {
        const json = this.toJSON();
        let result = new UserPreferences();
        result.init(json);
        return result;
    }
}

export interface IUserPreferences {
    featureHighlights?: IFeatureHighlights;
    addedGpts?: string[] | undefined;
    pinnedConversations?: string[] | undefined;
    speechToTextLanguage?: string | undefined;
    speechClickSend?: boolean | undefined;
    speechAutoSendNumSecs?: number | undefined;
    showLanguageSelectionInPrompt?: boolean | undefined;
}

export class UserRoleAssignment implements IUserRoleAssignment {
    userId?: string | undefined;
    role?: string | undefined;

    constructor(data?: IUserRoleAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): UserRoleAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["role"] = this.role;
        return data;
    }

    clone(): UserRoleAssignment {
        const json = this.toJSON();
        let result = new UserRoleAssignment();
        result.init(json);
        return result;
    }
}

export interface IUserRoleAssignment {
    userId?: string | undefined;
    role?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}